import React, { useEffect, useState } from "react";
import AnnounceCardComponent from "../../components/AnnounceCardComponent/AnnounceCardComponent";
import { Layout, Menu } from "antd";
import { GetReportById, GetReportById1, GetReportById2, GetReportById3 } from "../../Services/ReportService";
import { useHistory, useLocation } from "react-router-dom";
interface SearchData {
  announcement: string;
  department: string;
  dateRange: [string, string] | null;
}
interface LocationState {
  searchData?: SearchData;
}

const AnnouncementEpro = () => {
  let history = useHistory();
  const location = useLocation();
  const location2 = useLocation<LocationState>();
  const searchData = location2.state?.searchData;
  const searchParams = new URLSearchParams(location.search);
  const [announcement, setAnnouncement] = useState<any[]>([]);
  useEffect(() => {
    const fetchAnnouncement = async () => {
      const reportIdString = searchParams.get("Id");
      const reportId =
        reportIdString !== null ? parseInt(reportIdString, 10) : undefined;
      if (reportId !== undefined) {

        if (reportId === 13) {
          try {
            const Procurementannouncement = await GetReportById1();
            setAnnouncement(Procurementannouncement.dt_Report);
          } catch (error) {
            console.error("Failed to fetch report:", error);
          }
        }

        if (reportId === 14) {
          try {
            const Procurementannouncement = await GetReportById2();
            setAnnouncement(Procurementannouncement.dt_Report);
          } catch (error) {
            console.error("Failed to fetch report:", error);
          }
        }

        if (reportId === 15) {
          try {
            const Procurementannouncement = await GetReportById3();
            setAnnouncement(Procurementannouncement.dt_Report);
          } catch (error) {
            console.error("Failed to fetch report:", error);
          }
        }

      } else {
        console.log("sdadas", searchData?.announcement)
        if (searchData?.announcement == undefined) {
          try {
            const Procurementannouncement1 = await GetReportById1();
            const Procurementannouncement2 = await GetReportById2();
            const Procurementannouncement3 = await GetReportById3();

            // Concatenate all three dt_Report arrays
            const allData = [
              ...Procurementannouncement1.dt_Report,
              ...Procurementannouncement2.dt_Report,
              ...Procurementannouncement3.dt_Report,
            ];

            // Set the concatenated data
            setAnnouncement(allData);
          } catch (error) {
            console.error("Failed to fetch reports:", error);
          }
        } else {
          if (searchData?.announcement === "purchase") {
            try {
              const Procurementannouncement = await GetReportById1();
              const filteredData = Procurementannouncement.dt_Report.filter(
                (item: any) => {
                  let isValid = true;

                  // ตรวจสอบและฟิลเตอร์ตาม dateRange
                  if (searchData.dateRange) {
                    const [startDate, endDate] = searchData.dateRange;
                    const itemDate = item.Memo_RequestDate; // สมมติว่า Memo_RequestDate เป็นวันที่ใน item
                    isValid =
                      isValid && itemDate >= startDate && itemDate <= endDate;
                  }

                  // ตรวจสอบและฟิลเตอร์ตาม department
                  if (searchData.department) {
                    isValid = isValid && item.หน่วยงาน === searchData.department;
                  }

                  return isValid;
                }
              );
              setAnnouncement(filteredData);
            } catch (error) {
              console.error("Failed to fetch report:", error);
            }
          }
          if (searchData?.announcement == "result") {
            try {
              const Procurementannouncement = await GetReportById2();
              const filteredData = Procurementannouncement.dt_Report.filter(
                (item: any) => {
                  let isValid = true;

                  // ตรวจสอบและฟิลเตอร์ตาม dateRange
                  if (searchData.dateRange) {
                    const [startDate, endDate] = searchData.dateRange;
                    const itemDate = item.Memo_RequestDate; // สมมติว่า Memo_RequestDate เป็นวันที่ใน item
                    isValid =
                      isValid && itemDate >= startDate && itemDate <= endDate;
                  }

                  // ตรวจสอบและฟิลเตอร์ตาม department
                  if (searchData.department) {
                    isValid = isValid && item.หน่วยงาน === searchData.department;
                  }

                  return isValid;
                }
              );
              setAnnouncement(filteredData);
            } catch (error) {
              console.error("Failed to fetch report:", error);
            }
          }
          if (searchData?.announcement == "cancel") {
            try {
              const Procurementannouncement = await GetReportById3();
              const filteredData = Procurementannouncement.dt_Report.filter(
                (item: any) => {
                  let isValid = true;

                  // ตรวจสอบและฟิลเตอร์ตาม dateRange
                  if (searchData.dateRange) {
                    const [startDate, endDate] = searchData.dateRange;
                    const itemDate = item.Memo_RequestDate; // สมมติว่า Memo_RequestDate เป็นวันที่ใน item
                    isValid =
                      isValid && itemDate >= startDate && itemDate <= endDate;
                  }

                  // ตรวจสอบและฟิลเตอร์ตาม department
                  if (searchData.department) {
                    isValid = isValid && item.หน่วยงาน === searchData.department;
                  }

                  return isValid;
                }
              );
              setAnnouncement(filteredData);
            } catch (error) {
              console.error("Failed to fetch report:", error);
            }
          }
        }

      }
    };
    fetchAnnouncement();
  }, []);
  return (
    <Layout className="containers">
      <Menu mode="horizontal" defaultSelectedKeys={["1"]} className="nav">
        <img
          style={{
            // width: `${responeConfig?.cssConfig?.width}`,
            height: "70px",
            background: "white",
          }}
          className="img-logo"
          src={
            "https://e-procurement.wolfapprove.com//Images/Logo/trc_logo_no-bg.png"
          }
          alt="logo"
          onClick={() => history.push("/login")}
        />
        <div className="menu-items">
          <Menu.Item
            key="1"
            style={{
              display: "flex",
              alignItems: "center",
              color: location.pathname === "/login" ? "red" : "inherit",
            }}
          >
            <a onClick={() => history.push("/login")}>หน้าแรก</a>
          </Menu.Item>
          <Menu.Item key="2" style={{ display: "flex", alignItems: "center" }}>
            <a target="_blank" href="https://redcross.or.th/aboutus">
              ช่องทางการติดต่อ
            </a>
          </Menu.Item>
          <Menu.Item key="3" style={{ display: "flex", alignItems: "center" }}>
            <a
              target="_blank"
              href="https://e-procurement.wolfapprove.com/Document_Library/e045917b97624c9bb154941d8ac5bb10/WOLF_R2_User_Manual.pdf"
            >
              คู่มือการใช้งาน
            </a>
          </Menu.Item>
        </div>
      </Menu>
      <AnnounceCardComponent data={announcement} />
    </Layout>
  );
};

export default AnnouncementEpro;
